import React, { Component } from 'react';
import Layout from './components/Layout';
import { connect } from 'react-redux';
import Login from './components/Authentication/login';
import LoginError from './components/Authentication/LoginError';
import Error from './components/Error';
import Maintenance from './components/Authentication/Maintenance';
//import { Switch, Route } from 'react-router-dom';
import { getProfileFetch } from './store/action/profileFetchAction';

class App extends Component {
	constructor(props) {
		
		super(props);

		this.state = {
			token: localStorage.token,
			tokenExpiry: localStorage.tokenExpiry,
			isMaintenanceMode: 0,
			appEnvironment: ''
		}

		this.tokenHandler = this.tokenHandler.bind(this);
		this.userLoginFetch = this.userLoginFetch.bind(this);
	}

	componentDidMount = () => {
		this.fetchMaintenanceMode();
		this.props.getProfileFetch();

	}

	tokenHandler(jwt) {
		this.setState({ token: jwt });
	}

	userLoginFetch(userInfo) {
	}

	fetchMaintenanceMode = () => {

		const urlParams = new URLSearchParams(window.location.search);
		const isQueryModeOn = urlParams.get('querymode') === 'on';

		fetch("/api/Auth/appinfo")
			.then(response => response.json())
			.then(data => {

				const maintenanceMode = isQueryModeOn
					? 0
					: Number.parseInt(data?.maintenanceFlag, 10);

				this.setState({
					isMaintenanceMode: Number.isNaN(maintenanceMode) ? 0 : maintenanceMode,
					appEnvironment: data?.appEnvironment ?? ''
				});
				
			})
			.catch(err => {
				this.setState({
					isMaintenanceMode: 0,
					appEnvironment: ''
				}); 
			});
	}

	redirectToErpLoginIfNeeded() {
		// A fresh SSO launch from Nexelus carries an ssotoken; let Login handle it instead of
		// redirecting back to Nexelus because of stale expired-session values in localStorage.
		const ssoToken = new URLSearchParams(window.location.search).get("ssotoken");
		if (ssoToken) {
			return false;
		}

		const loginSource = localStorage.getItem("loginSource");
		const erpLoginUrl = localStorage.getItem("erpLoginUrl");
		const hasExpiredToken = this.state.token && this.state.tokenExpiry != null && Date.now() > Date.parse(this.state.tokenExpiry);

		if (hasExpiredToken && loginSource && loginSource==="nexelus" && erpLoginUrl) {
			localStorage.removeItem("token");
			localStorage.removeItem("tokenExpiry");
			localStorage.removeItem("authenticatedUser");
			localStorage.removeItem("userInfo");
			localStorage.removeItem("sysNames");
			localStorage.removeItem("loginSource");
			localStorage.removeItem("erpLoginUrl");
			window.location = erpLoginUrl;
			return true;
		}
		return false;
	}

	render() {

		if (this.redirectToErpLoginIfNeeded()) {
			return null;
		}
		return (
			<div>
				{
					(window.location.pathname.substring() === "/error") ? <Error /> :
						(window.location.pathname.substring() === "/loginerror") ? <LoginError /> :
							this.state.isMaintenanceMode === 1 ? <Maintenance /> :
								this.state.token && !(this.state.tokenExpiry != null && Date.now() > Date.parse(this.state.tokenExpiry)) ? <Layout tokenHandler={this.tokenHandler} userLoginFetch={this.userLoginFetch} appEnvironment={this.state.appEnvironment} /> : <Login tokenHandler={this.tokenHandler} userLoginFetch={this.userLoginFetch} />
				}
			</div>
		);
	}
}

const mapDispatchToProps = dispatch => ({
	getProfileFetch: () => dispatch(getProfileFetch())
})

export default connect(null, mapDispatchToProps)(App);